import courseImg01 from "assets/images/course/01.jpg";
import courseImg02 from "assets/images/course/02.jpg";
import courseImg03 from "assets/images/course/03.jpg";
import courseImg04 from "assets/images/course/04.jpg";
import courseImg05 from "assets/images/course/05.jpg";
import courseImg06 from "assets/images/course/06.jpg";

import courseAuthorImg01 from "assets/images/course/author/01.jpg";
import courseAuthorImg02 from "assets/images/course/author/02.jpg";
import courseAuthorImg03 from "assets/images/course/author/03.jpg";
import courseAuthorImg04 from "assets/images/course/author/04.jpg";
import courseAuthorImg05 from "assets/images/course/author/05.jpg";
import courseAuthorImg06 from "assets/images/course/author/06.jpg";

const courseListOne = [
	{
		id: 1,
		username: "geverington0",
		imgUrl: courseImg01,
		randomAlt: "Stronghold",
		imgAlt: "mydevtoolkit, Stronghold",
		rawPrice: 86,
		cate: "Solarbreeze",
		reviewCount: 77,
		schdule: "Online Class, Self Paced",
		title: "Beginning C++ Programming - From Beginner to Beyond",
		authorImgUrl: courseAuthorImg01,
		authorImgAlt: "mydevtoolkit, geverington0",
		authorName: "Godiva Everington",
		totalLeson: 54,
		btnText: "Read More",
		email: "geverington0@hud.gov",
		price: "$86"
	},
	{
		id: 2,
		username: "rmarginson1",
		imgUrl: courseImg02,
		randomAlt: "Zamit",
		imgAlt: "mydevtoolkit, Zamit",
		rawPrice: 90,
		cate: "Pannier",
		reviewCount: 25,
		schdule: "Online Class, Self Paced",
		title: "Learn Python Programming Masterclass",
		authorImgUrl: courseAuthorImg02,
		authorImgAlt: "mydevtoolkit, rmarginson1",
		authorName: "Rusty Marginson",
		totalLeson: 66,
		btnText: "Read More",
		email: "rmarginson1@dailymail.co.uk",
		price: "$90"
	},
	{
		id: 3,
		username: "dbowshire2",
		imgUrl: courseImg03,
		randomAlt: "Sonsing",
		imgAlt: "mydevtoolkit, Sonsing",
		rawPrice: 94,
		cate: "Zontrax",
		reviewCount: 81,
		schdule: "Online Class, Self Paced",
		title: "Pre-Programming: Everything you need to know before you code",
		authorImgUrl: courseAuthorImg03,
		authorImgAlt: "mydevtoolkit, dbowshire2",
		authorName: "Donnie Bowshire",
		totalLeson: 89,
		btnText: "Read More",
		email: "dbowshire2@sciencedaily.com",
		price: "$94"
	},
	{
		id: 4,
		username: "dblindmann3",
		imgUrl: courseImg04,
		randomAlt: "Cookley",
		imgAlt: "mydevtoolkit, Cookley",
		rawPrice: 92,
		cate: "Voyatouch",
		reviewCount: 39,
		schdule: "Online Class, Self Paced",
		title: "Java Programming Masterclass covering Java 11 & Java 17",
		authorImgUrl: courseAuthorImg04,
		authorImgAlt: "mydevtoolkit, dblindmann3",
		authorName: "Dorree Blindmann",
		totalLeson: 86,
		btnText: "Read More",
		email: "dblindmann3@phoca.cz",
		price: "$92"
	},
	{
		id: 5,
		username: "sferson4",
		imgUrl: courseImg05,
		randomAlt: "Toughjoyfax",
		imgAlt: "mydevtoolkit, Toughjoyfax",
		rawPrice: 83,
		cate: "Konklab",
		reviewCount: 71,
		schdule: "Online Class, Self Paced",
		title: "Java Programming for Complete Beginners",
		authorImgUrl: courseAuthorImg05,
		authorImgAlt: "mydevtoolkit, sferson4",
		authorName: "Sascha Ferson",
		totalLeson: 53,
		btnText: "Read More",
		email: "sferson4@google.it",
		price: "$83"
	},
	{
		id: 6,
		username: "skindle5",
		imgUrl: courseImg06,
		randomAlt: "Bamity",
		imgAlt: "mydevtoolkit, Bamity",
		rawPrice: 92,
		cate: "Biodex",
		reviewCount: 43,
		schdule: "Online Class, Self Paced",
		title: "Automate the Boring Stuff with Python Programming",
		authorImgUrl: courseAuthorImg06,
		authorImgAlt: "mydevtoolkit, skindle5",
		authorName: "Scarlet Kindle",
		totalLeson: 51,
		btnText: "Read More",
		email: "skindle5@time.com",
		price: "$92"
	},
	{
		id: 7,
		username: "ksans6",
		imgUrl: "https://robohash.org/quasiperferendisnisi.png?size=50x50&set=set1",
		randomAlt: "Redhold",
		imgAlt: "mydevtoolkit, Redhold",
		rawPrice: 96,
		cate: "Biodex",
		reviewCount: 39,
		schdule: "Online Class, Self Paced",
		title: "Learn JAVA Programming - Beginner to Master",
		authorImgUrl: "https://robohash.org/voluptatuminventoredebitis.png?size=50x50&set=set1",
		authorImgAlt: "mydevtoolkit, ksans6",
		authorName: "Kahaleel Sans",
		totalLeson: 62,
		btnText: "Read More",
		email: "ksans6@live.com",
		price: "$96"
	},
	{
		id: 8,
		username: "bcocke7",
		imgUrl: "https://robohash.org/cumsintvel.png?size=50x50&set=set1",
		randomAlt: "Cardify",
		imgAlt: "mydevtoolkit, Cardify",
		rawPrice: 95,
		cate: "Stringtough",
		reviewCount: 28,
		schdule: "Online Class, Self Paced",
		title: "C Programming For Beginners - Master the C Language",
		authorImgUrl: "https://robohash.org/nostrumrationeet.png?size=50x50&set=set1",
		authorImgAlt: "mydevtoolkit, bcocke7",
		authorName: "Billie Cocke",
		totalLeson: 63,
		btnText: "Read More",
		email: "bcocke7@feedburner.com",
		price: "$95"
	},
	{
		id: 9,
		username: "imclaggan8",
		imgUrl: "https://robohash.org/placeatetfacilis.png?size=50x50&set=set1",
		randomAlt: "Ventosanzap",
		imgAlt: "mydevtoolkit, Ventosanzap",
		rawPrice: 80,
		cate: "Subin",
		reviewCount: 84,
		schdule: "Online Class, Self Paced",
		title: "C Programming Bootcamp - The Complete C Language Course",
		authorImgUrl: "https://robohash.org/aliquamvoluptasexpedita.png?size=50x50&set=set1",
		authorImgAlt: "mydevtoolkit, imclaggan8",
		authorName: "Irina McLaggan",
		totalLeson: 55,
		btnText: "Read More",
		email: "imclaggan8@time.com",
		price: "$80"
	},
	{
		id: 10,
		username: "dzanioletti9",
		imgUrl: "https://robohash.org/consecteturipsaquis.png?size=50x50&set=set1",
		randomAlt: "Viva",
		imgAlt: "mydevtoolkit, Viva",
		rawPrice: 95,
		cate: "Stringtough",
		reviewCount: 23,
		schdule: "Online Class, Self Paced",
		title: "Computer Science 101: Master the Theory Behind Programming",
		authorImgUrl: "https://robohash.org/nisiisteimpedit.png?size=50x50&set=set1",
		authorImgAlt: "mydevtoolkit, dzanioletti9",
		authorName: "Darcey Zanioletti",
		totalLeson: 52,
		btnText: "Read More",
		email: "dzanioletti9@hugedomains.com",
		price: "$95"
	},
	{
		id: 11,
		username: "skema",
		imgUrl: "https://robohash.org/blanditiisdolorumculpa.png?size=50x50&set=set1",
		randomAlt: "Quo Lux",
		imgAlt: "mydevtoolkit, Quo Lux",
		rawPrice: 96,
		cate: "Tampflex",
		reviewCount: 68,
		schdule: "Online Class, Self Paced",
		title: "Programming for Kids and Beginners: Learn to Code in Scratch",
		authorImgUrl: "https://robohash.org/eligendisintquo.png?size=50x50&set=set1",
		authorImgAlt: "mydevtoolkit, skema",
		authorName: "Sherye Kem",
		totalLeson: 57,
		btnText: "Read More",
		email: "skema@mozilla.org",
		price: "$96"
	},
	{
		id: 12,
		username: "cbasezzib",
		imgUrl: "https://robohash.org/omnisundeexercitationem.png?size=50x50&set=set1",
		randomAlt: "Zoolab",
		imgAlt: "mydevtoolkit, Zoolab",
		rawPrice: 95,
		cate: "Cookley",
		reviewCount: 78,
		schdule: "Online Class, Self Paced",
		title: "Competitive Programming Essentials,  Master Algorithms 2022",
		authorImgUrl: "https://robohash.org/deseruntlaboreillo.png?size=50x50&set=set1",
		authorImgAlt: "mydevtoolkit, cbasezzib",
		authorName: "Chelsea Basezzi",
		totalLeson: 95,
		btnText: "Read More",
		email: "cbasezzib@google.de",
		price: "$95"
	},
	{
		id: 13,
		username: "kbadsworthc",
		imgUrl: "https://robohash.org/inhicporro.png?size=50x50&set=set1",
		randomAlt: "Flowdesk",
		imgAlt: "mydevtoolkit, Flowdesk",
		rawPrice: 86,
		cate: "Otcom",
		reviewCount: 36,
		schdule: "Online Class, Self Paced",
		title: "Introduction to Computer Programming for Beginners 2022",
		authorImgUrl: "https://robohash.org/magnamaccusantiumiure.png?size=50x50&set=set1",
		authorImgAlt: "mydevtoolkit, kbadsworthc",
		authorName: "Kermie Badsworth",
		totalLeson: 92,
		btnText: "Read More",
		email: "kbadsworthc@trellian.com",
		price: "$86"
	},
	{
		id: 14,
		username: "kmeehand",
		imgUrl: "https://robohash.org/doloresestdolor.png?size=50x50&set=set1",
		randomAlt: "Konklux",
		imgAlt: "mydevtoolkit, Konklux",
		rawPrice: 83,
		cate: "Asoka",
		reviewCount: 100,
		schdule: "Online Class, Self Paced",
		title: "Complete C# Masterclass",
		authorImgUrl: "https://robohash.org/molestiasassumendavoluptatum.png?size=50x50&set=set1",
		authorImgAlt: "mydevtoolkit, kmeehand",
		authorName: "Kacy Meehan",
		totalLeson: 62,
		btnText: "Read More",
		email: "kmeehand@newyorker.com",
		price: "$83"
	},
	{
		id: 15,
		username: "esloame",
		imgUrl: "https://robohash.org/quasirecusandaedolore.png?size=50x50&set=set1",
		randomAlt: "Cardguard",
		imgAlt: "mydevtoolkit, Cardguard",
		rawPrice: 99,
		cate: "Alpha",
		reviewCount: 41,
		schdule: "Online Class, Self Paced",
		title: "Learn C++ Programming -Beginner to Advance- Deep Dive in C++",
		authorImgUrl: "https://robohash.org/accusamusvoluptatesvoluptate.png?size=50x50&set=set1",
		authorImgAlt: "mydevtoolkit, esloame",
		authorName: "Emmalynne Sloam",
		totalLeson: 67,
		btnText: "Read More",
		email: "esloame@wiley.com",
		price: "$99"
	},
	{
		id: 16,
		username: "dolletf",
		imgUrl: "https://robohash.org/nihiloditeius.png?size=50x50&set=set1",
		randomAlt: "Biodex",
		imgAlt: "mydevtoolkit, Biodex",
		rawPrice: 100,
		cate: "Zontrax",
		reviewCount: 64,
		schdule: "Online Class, Self Paced",
		title: "Complete Python Programming Masterclass Beginner to Advanced",
		authorImgUrl: "https://robohash.org/natusutdolor.png?size=50x50&set=set1",
		authorImgAlt: "mydevtoolkit, dolletf",
		authorName: "Doralynne Ollet",
		totalLeson: 77,
		btnText: "Read More",
		email: "dolletf@fastcompany.com",
		price: "$100"
	},
	{
		id: 17,
		username: "mtuxsellg",
		imgUrl: "https://robohash.org/illoenimtempore.png?size=50x50&set=set1",
		randomAlt: "Prodder",
		imgAlt: "mydevtoolkit, Prodder",
		rawPrice: 80,
		cate: "Holdlamis",
		reviewCount: 74,
		schdule: "Online Class, Self Paced",
		title: "Microcontroller Embedded C Programming: Absolute Beginners",
		authorImgUrl: "https://robohash.org/vitaeaperiamrerum.png?size=50x50&set=set1",
		authorImgAlt: "mydevtoolkit, mtuxsellg",
		authorName: "Muire Tuxsell",
		totalLeson: 85,
		btnText: "Read More",
		email: "mtuxsellg@wikipedia.org",
		price: "$80"
	},
	{
		id: 18,
		username: "tferrillioh",
		imgUrl: "https://robohash.org/autquiquia.png?size=50x50&set=set1",
		randomAlt: "Zathin",
		imgAlt: "mydevtoolkit, Zathin",
		rawPrice: 98,
		cate: "Alphazap",
		reviewCount: 68,
		schdule: "Online Class, Self Paced",
		title: "C++ Fundamentals: Game Programming For Beginners",
		authorImgUrl: "https://robohash.org/quameiuset.png?size=50x50&set=set1",
		authorImgAlt: "mydevtoolkit, tferrillioh",
		authorName: "Timmy Ferrillio",
		totalLeson: 54,
		btnText: "Read More",
		email: "tferrillioh@sohu.com",
		price: "$98"
	},
	{
		id: 19,
		username: "cdingivani",
		imgUrl: "https://robohash.org/autetalias.png?size=50x50&set=set1",
		randomAlt: "Sonsing",
		imgAlt: "mydevtoolkit, Sonsing",
		rawPrice: 97,
		cate: "Keylex",
		reviewCount: 38,
		schdule: "Online Class, Self Paced",
		title: "Selenium Webdriver with PYTHON from Scratch + Frameworks",
		authorImgUrl: "https://robohash.org/quidemnesciuntconsectetur.png?size=50x50&set=set1",
		authorImgAlt: "mydevtoolkit, cdingivani",
		authorName: "Cletus Dingivan",
		totalLeson: 70,
		btnText: "Read More",
		email: "cdingivani@ucsd.edu",
		price: "$97"
	},
	{
		id: 20,
		username: "opeardej",
		imgUrl: "https://robohash.org/uteafugiat.png?size=50x50&set=set1",
		randomAlt: "Aerified",
		imgAlt: "mydevtoolkit, Aerified",
		rawPrice: 84,
		cate: "Span",
		reviewCount: 72,
		schdule: "Online Class, Self Paced",
		title: "Python for Absolute Beginners",
		authorImgUrl: "https://robohash.org/automnisaut.png?size=50x50&set=set1",
		authorImgAlt: "mydevtoolkit, opeardej",
		authorName: "Odelle Pearde",
		totalLeson: 64,
		btnText: "Read More",
		email: "opeardej@quantcast.com",
		price: "$84"
	}
];

export { courseListOne };
